import { RootState } from 'store/root-reducer';

export const getVrpDetectStatistic = (state: RootState) => state.statistics.vrpDetectStatistic;
